import {
    backButton,
    init as initSDK,
    miniApp,
    themeParams,
    viewport,
    setDebug,
} from '@telegram-apps/sdk-react';

export async function init(options: { debug: boolean }): Promise<void> {
    setDebug(options.debug);
    initSDK();

    // Mount scopes. Each call is idempotent and side-effect free if the
    // platform doesn't support that capability — we just check first.
    if (backButton.isSupported()) {
        backButton.mount();
    }
    miniApp.mountSync();
    themeParams.mountSync();
    void viewport
        .mount()
        .catch((error: unknown) => {
            console.error('[miniapp] viewport mount failed', error);
        });

    // Project Telegram-supplied colours into CSS variables so plain CSS in
    // index.css can reference --tg-theme-* without manual sync.
    miniApp.bindCssVars();
    themeParams.bindCssVars();
    viewport.bindCssVars();

    // Tell Telegram we're ready (removes the spinner overlay).
    miniApp.ready();
}
